import http from "./httpService";

const apiEndPoint = "/machines/";

export function getServerByHostname(server) {
  const url = `${apiEndPoint}get_by_hostname/${server}/`;
  return http.get(url);
}

export function getServerById(id) {
  const url = `${apiEndPoint}get_by_id/${id}/`;
  return http.get(url);
}

export function getAllReachableServers(params) {
  const url = `${apiEndPoint}all_reachable_servers/`;
  return http.post(url, params);
}

export function getCloudServerByHostname(server) {
  const url = `${apiEndPoint}get_by_hostname/${server}/`;
  return http.get(url);
}

export function getCloudServerById(id) {
  const url = `${apiEndPoint}get_by_id/${id}/`;
  return http.get(url);
}

export function disableServer(machineId) {
  const url = `/machine/disable/${machineId}/`;
  return http.put(url);
}

export function getAuthorizedGroups() {
  const url = "/locations/list_authorized_groups";
  return http.get(url);
}

export function getGroupByName(name) {
  const url = `/groups/get_by_name/${encodeURIComponent(name)}/`;
  return http.get(url);
}

export function getHardwareSpecificationsByHostname(hostname) {
  const url = `/inference-machine-specs/${hostname}/`;
  return http.get(url);
}

export function pingCloudChauffeur(hostname) {
  const url = `/locations/chauffeur/version/${hostname}`;
  return http.get(url);
}
